import { ComponentType } from 'react';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';
import { AddPaymentMethod } from '~/pages/PaymentMethod/PaymentMethod';

import { ReferralProgramModal as ModalReferralProgram } from '../../pages/ReferralProgram/ReferralProgramModal';

import { type ModalProps, ModalType } from '../Modal/interface';
import Modal3DS from '../Modal3DS/Modal3DS';
import ModalAddressList from '../ModalAddressList/ModalAddressList';
import ModalAddressListV3 from '../ModalAddressListV3/ModalAddressList';
import ModalAgeRestricted from '../ModalAgeRestricted/ModalAgeRestricted';
import ModalAuth from '../ModalAuth/ModalAuth';
import ModalAuthHeim from '../ModalAuthHeim/ModalAuthHeim';
import { ModalAuthV3 } from '../ModalAuthV3';
import { ModalBirthDate } from '../ModalBirthDate';
import ModalChangeEmail from '../ModalChangeEmail/ModalChangeEmail';
import ModalChangeEmailV3 from '../ModalChangeEmailV3';
import ModalChangeName from '../ModalChangeName/ModalChangeName';
import ModalChangeNotifications from '../ModalChangeNotifications/ModalChangeNotifications';
import ModalCheckoutReciever from '../ModalCheckoutReciever/ModalCheckoutReciever';
import ModalCheckoutRecieverCD from '../ModalCheckoutRecieverCD';
import ModalComment from '../ModalComment/ModalComment';
import ModalDeleteAccount from '../ModalDeleteAccount/ModalDeleteAccount';
import ModalDeleteAddress from '../ModalDeleteAddress/ModalDeleteAddress';
import ModalDeleteCard from '../ModalDeleteCard/ModalDeleteCard';
import ModalDeliveryAddress from '../ModalDeliveryAddress/ModalDeliveryAddress';
import ModalDeliveryInfo from '../ModalDeliveryInfo/ModalDeliveryInfo';
import ModalDeliveryInfoCD from '../ModalDeliveryInfoCD';
import ModalDeliveryInfoCDV3 from '../ModalDeliveryInfoCDV3';
import ModalEditAddressDetails from '../ModalEditAddressDetails';
import ModalEditAddressDetailsV3 from '../ModalEditAddressDetailsV3';
import ModalEditAddressLocation from '../ModalEditAddressLocation';
import ModalEditAddressLocationV3 from '../ModalEditAddressLocationV3';
import ModalFeedback from '../ModalFeedback/ModalFeedback';
import ModalFeedbackSuccess from '../ModalFeedback/ModalFeedbackSuccess';
import ModalLogout from '../ModalLogout/ModalLogout';
import ModalLogoutV3 from '../ModalLogoutV3';
import { ModalOutOfZone } from '../ModalOutOfZone/ModalOutOfZone';
import ModalProductDetails from '../ModalProductDetails/ModalProductDetails';
import ModalPromocode from '../ModalPromocode/ModalPromocode';
import ModalRateApp from '../ModalRateApp/ModalRateApp';
import { ModalRecommendations } from '../ModalRecommendations';
import ModalSelectProductSKU from '../ModalSelectProductSKU/ModalSelectProductSKU';
import ModalSelectProductSKUV3 from '../ModalSelectProductSKUV3/ModalSelectProductSKU';
import ModalSlotsSelectDate from '../ModalSlotsSelectDate/ModalSlotsSelectDate';
import ModalSlotsSelectDateCD from '../ModalSlotsSelectDateCD/ModalSlotsSelectDateCD';
import ModalSlotsSelectDateV3 from '../ModalSlotsSelectDateV3/ModalSlotsSelectDateV3';
import ModalSubscription from '../ModalSubscription/ModalSubscription';
import ModalTransactionDetails from '../ModalTransactionDetails/ModalTransactionDetails';

type StatusColor = 'dark-content' | 'light-content';

interface ModalMapItem {
  statusColor: StatusColor;
  component: ComponentType<Pick<ModalProps, 'isShow'>>;
}

const map = new Map<ModalType, ModalMapItem>([
  [
    ModalType.Auth,
    {
      component: company.match({
        [CompanyName.CityDrinks]: company.newDesignSystemEnabled
          ? ModalAuthV3
          : ModalAuth,
        [CompanyName.Heimkaup]: ModalAuthHeim,
        v3: ModalAuthV3,
        default: ModalAuth,
      }),
      statusColor: 'dark-content',
    },
  ],
  [
    ModalType.AgeRestriction,
    { component: ModalAgeRestricted, statusColor: 'light-content' },
  ],
  [
    ModalType.BirthDate,
    { component: ModalBirthDate, statusColor: 'dark-content' },
  ],
  [
    ModalType.ChangeEmail,
    {
      component: company.newDesignSystemEnabled
        ? ModalChangeEmailV3
        : ModalChangeEmail,
      statusColor: 'dark-content',
    },
  ],
  [
    ModalType.ChangeName,
    { component: ModalChangeName, statusColor: 'dark-content' },
  ],
  [
    ModalType.ChangeNotifications,
    { component: ModalChangeNotifications, statusColor: 'dark-content' },
  ],
  [
    ModalType.CheckoutReciever,
    {
      component: company.match({
        [CompanyName.CityDrinks]: ModalCheckoutRecieverCD,
        v3: ModalCheckoutRecieverCD,
        default: ModalCheckoutReciever,
      }),
      statusColor: 'dark-content',
    },
  ],
  [
    ModalType.CheckoutAddRecieverData,
    {
      component: company.match({
        [CompanyName.CityDrinks]: ModalCheckoutRecieverCD,
        v3: ModalCheckoutRecieverCD,
        default: ModalCheckoutReciever,
      }),
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.Comment,
    { component: ModalComment, statusColor: 'light-content' },
  ],
  [
    ModalType.DeleteAccount,
    { component: ModalDeleteAccount, statusColor: 'dark-content' },
  ],
  [
    ModalType.DeleteAddress,
    { component: ModalDeleteAddress, statusColor: 'dark-content' },
  ],
  [
    ModalType.DeleteCard,
    { component: ModalDeleteCard, statusColor: 'dark-content' },
  ],
  [
    ModalType.DeliveryAddress,
    { component: ModalDeliveryAddress, statusColor: 'dark-content' },
  ],
  [
    ModalType.DeliveryInfo,
    {
      component: company.match({
        [CompanyName.CityDrinks]: company.newDesignSystemEnabled
          ? ModalDeliveryInfoCDV3
          : ModalDeliveryInfoCD,
        v3: ModalDeliveryInfoCDV3,
        default: ModalDeliveryInfo,
      }),
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.EditAddressDetails,
    {
      component: company.newDesignSystemEnabled
        ? ModalEditAddressDetailsV3
        : ModalEditAddressDetails,
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.EditAddressLocation,
    {
      component: company.newDesignSystemEnabled
        ? ModalEditAddressLocationV3
        : ModalEditAddressLocation,
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.Feedback,
    { component: ModalFeedback, statusColor: 'dark-content' },
  ],
  [
    ModalType.FeedbackSuccess,
    { component: ModalFeedbackSuccess, statusColor: 'dark-content' },
  ],
  [
    ModalType.Logout,
    {
      component: company.newDesignSystemEnabled ? ModalLogoutV3 : ModalLogout,
      statusColor: 'dark-content',
    },
  ],
  [
    ModalType.OutOfZone,
    { component: ModalOutOfZone, statusColor: 'light-content' },
  ],
  [
    ModalType.ProductDetails,
    { component: ModalProductDetails, statusColor: 'light-content' },
  ],
  [
    ModalType.Promocode,
    { component: ModalPromocode, statusColor: 'dark-content' },
  ],
  [ModalType.RateApp, { component: ModalRateApp, statusColor: 'dark-content' }],
  [
    ModalType.Recommendations,
    { component: ModalRecommendations, statusColor: 'dark-content' },
  ],
  [
    ModalType.ReferralProgram,
    { component: ModalReferralProgram, statusColor: 'dark-content' },
  ],
  [
    ModalType.SelectDate,
    { component: ModalSlotsSelectDate, statusColor: 'dark-content' },
  ],
  [
    ModalType.SelectDateCD,
    {
      component: company.newDesignSystemEnabled
        ? ModalSlotsSelectDateV3
        : ModalSlotsSelectDateCD,
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.Subscription,
    { component: ModalSubscription, statusColor: 'dark-content' },
  ],
  [
    ModalType.SubscriptionOff,
    { component: ModalSubscription, statusColor: 'dark-content' },
  ],
  [
    ModalType.DeliveryAddressList,
    {
      component: company.newDesignSystemEnabled
        ? ModalAddressListV3
        : ModalAddressList,
      statusColor: 'light-content',
    },
  ],
  [ModalType.Check3Ds, { component: Modal3DS, statusColor: 'dark-content' }],
  [
    ModalType.SelectSKU,
    {
      component: company.newDesignSystemEnabled
        ? ModalSelectProductSKUV3
        : ModalSelectProductSKU,
      statusColor: 'light-content',
    },
  ],
  [
    ModalType.AddCard,
    { component: AddPaymentMethod, statusColor: 'dark-content' },
  ],
  [
    ModalType.TransactionDetails,
    { component: ModalTransactionDetails, statusColor: 'dark-content' },
  ],
]);

export default map;
